/* The inspection the user is currently working, and the bank/branch scope the
   non-inspection screens are filtered by. Both are session state, not data. */
const InspectionActionType = {
  INSPECTION_SET_ACTIVE: 'inspection_set_active',
  INSPECTION_CLEAR: 'inspection_clear',
  SCOPE_SET: 'scope_set',
} as const;

export default InspectionActionType;

/** Enough to label the workspace without re-fetching; the rest comes from the API. */
export interface ActiveInspection {
  id: number;
  ref: string | null;
  entityCode: string | null;
  branchId: number | null;
  branchName: string | null;
  dccbId: number | null;
  dccbName: string | null;
}

/** Bank (+ optional branch) the follow-up screens are filtered to. */
export interface Scope {
  dccbId: number | null;
  branchId: number | null;
}
